export default __webpack_public_path__ + "static/media/SwapRight.a98b1661.svg";